import { decodeOneOf, encodeOneOf } from '../../../../domain';
import { RestrictedKeys } from '../restricted.key';
import { Places } from '../../../route-consts';
/** Prefixo dos nomes deste arquivo na intencao - unico na aplicacao (ver `url-codes.test.ts`). */
const PREFIX = 'my';
/** Os parametros deste place: vao para o endereco. */
const P = {
    /**
     * Qual ESCOPO a tela de Configuracoes esta editando - voce, a empresa ou o sistema.
     *
     * Mora no endereco como qualquer estado de tela: um link para "os limites padrao"
     * tem de abrir neles, e o F5 nao pode devolver o leitor para a primeira aba.
     */
    MyDataTab: `${PREFIX}a`
};
/**
 * O codigo de cada aba no endereco.
 *
 * `conta` e o padrao e por isso nao aparece na URL - so os outros dois escopos
 * precisam ser ditos. Tabela explicita, e nao o indice do array: a ordem das abas e
 * de exibicao e pode mudar, e com indice aquele dia mudaria calado o significado de
 * todo endereco salvo.
 */
export const MY_DATA_TAB_CODES = {
    '0': 'conta',
    '1': 'empresa',
    '2': 'sistema'
};
export class MyDataKeys extends RestrictedKeys {
    get place() {
        return Places.myData;
    }
    get tab() {
        return decodeOneOf(this._intent.getParameterAsString(P.MyDataTab), MY_DATA_TAB_CODES, 'conta');
    }
    set tab(value) {
        this._intent.setParameter(P.MyDataTab, value === 'conta' ? undefined : encodeOneOf(value, MY_DATA_TAB_CODES));
    }
}
//# sourceMappingURL=my-data.key.js.map